<template>
  <div
    class="
      relative
      flex
      items-top
      justify-center
      min-h-screen
      bg-gray-100
    "
  >
    <div class="max-w-6xl mx-auto sm:px-6 lg:px-8">
      <div class="flex justify-center pt-8 sm:justify-start">
        <img
          src="/img/logo-thnic.svg"
          class="h-20 w-auto text-gray-700 sm:h-20"
        />
        <div class="ml-5">
          <div class="text-sm sm:text-2xl">
            โครงการส่งเสริมธุรกิจไทยใช้พาณิชย์อิเล็กทรอนิกส์
          </div>
          <div
            v-if="type == 'C'"
            class="text-2xl sm:text-4xl text-blue-900 mt-1"
          >
            แบบลงทะเบียนสำหรับนิติบุคคล
          </div>
          <div v-else class="text-2xl sm:text-3xl text-blue-900 mt-2">
            แบบลงทะเบียนสำหรับบุคคลธรรมดา
          </div>
        </div>
      </div>
      <div class="bg-white overflow-hidden shadow sm:rounded-lg">
        <div class="bg-blue-900 px-6 py-8">
          <div class="text-white text-center text-xl font-semibold">
            <span class="text-yellow-500">Step 1</span> :
            เลือกและตรวจสอบชื่อเว็บไซต์/โดเมน<span
              class="font-normal underline text-lg ml-2"
              >ไม่ต้องใส่ www.</span
            >
          </div>
          <div v-if="type == 'C'" class="mt-3 text-white text-sm text-center">
            สำหรับเว็บไซต์/โดเมน
            <span class="text-yellow-500 font-semibold">.co.th</span>
            ชื่อเว็บไซต์/โดเมนจำเป็นต้องสอดคล้อง, เป็นส่วนใดส่วนหนึ่ง
            หรือย่อมาจากชื่อองค์กรเท่านั้น (ห้ามมีคำหรือตัวอักษรที่ไม่อยู่ในชื่อนิติบุคคล)
          </div>
          <div class="mt-6 text-white text-xl text-center">
            หลักเกณฑ์การตั้งชื่อเว็บไซต์/โดเมน <span class="text-yellow-500 font-semibold">.th</span>
          </div>
          <div class="mt-3 text-white text-sm text-left">
            <ul class="text-sm font-medium">
                <li class="w-full px-4 py-2">1. ชื่อเว็บไซต์/โดเมน <span class="text-yellow-500 font-semibold">.th</span> แต่ละชื่อจะต้องประกอบด้วยตัวอักษรภาษาอังกฤษ (a-z) และ/หรือ ตัวเลขอารบิค(0-9)</li>
                <li class="w-full px-4 py-2">2. ชื่อเว็บไซต์/โดเมนสามารถประกอบด้วยเครื่องหมายยัติภังค์ “-” คั่นระหว่างตัวอักษรหรือตัวเลขได้ แต่ต้องไม่ใช้เรียงติดกันมากกว่า 1 ตัว นอกจากนี้ ไม่อนุญาตให้ใช้เป็นตัวอักษรแรกหรือตัวอักษรสุดท้ายของชื่อเว็บไซต์/โดเมน</li>
            </ul>
          </div>
          <div class="mt-4 flex justify-center h-10">
            <input
              v-model="form.domain_name"
              placeholder="ชื่อเว็บไซต์/โดเมนที่ต้องการ"
              class="
                px-3
                border-gray-300
                focus:border-indigo-300
                focus:ring focus:ring-indigo-200 focus:ring-opacity-50
                rounded-md
                shadow-sm
              "
              @keyup="startAgain"
            />
            <select
              v-model="form.tld"
              class="
                ml-1
                border-gray-300
                focus:border-indigo-300
                focus:ring focus:ring-indigo-200 focus:ring-opacity-50
                rounded-md
                shadow-sm
              "
              @change="startAgain"
            >
              <option
                v-for="(tld, index) in tlds"
                :key="`bt-${index}`"
                :value="tld"
              >
                {{ tld }}
              </option>
            </select>
            <button
              class="
                ml-2
                px-4
                bg-yellow-500
                border border-transparent
                rounded-md
                text-sm
                sm:text-base
                text-white
                tracking-widest
                hover:bg-yellow-600
                active:bg-yellow-700
                focus:outline-none
                focus:border-yellow-700
                focus:shadow-outline-white
                transition
                ease-in-out
                duration-150
              "
              :class="{
                'opacity-70': form.processing || isChecking || !isDomainValid,
              }"
              :disabled="form.processing || isChecking || !isDomainValid"
              @click="checkDomain"
            >
              ตรวจสอบชื่อว่าง
            </button>
          </div>
          <div v-show="domainResult" class="mt-4">
            <p class="text-center" :class="{'text-green-200': isOpenNextSteps, 'text-yellow-300': !isOpenNextSteps }">
              {{ domainResult }}
            </p>
          </div>
          <div v-show="form.errors.domain_name" class="mt-2">
            <p class="text-sm text-yellow-300 text-center">
              {{ form.errors.domain_name }}
            </p>
            <p class="text-sm text-yellow-300 text-center">
              {{ form.errors.domain }}
            </p>
          </div>
        </div>

        <form v-show="isOpenNextSteps" @submit.prevent="doRegistration">
          <div class="px-6 py-8">
            <div
              v-if="type == 'C'"
              class="text-blue-900 text-center text-xl font-semibold"
            >
              <span class="text-yellow-500">Step 2</span> : กรอกข้อมูลนิติบุคคล
            </div>
            <div v-else class="text-blue-900 text-center text-xl font-semibold">
              <span class="text-yellow-500">Step 2</span> :
              กรอกข้อมูลผู้ประกอบการ
            </div>
            <div class="text-red-700 text-sm">*จำเป็นต้องกรอก</div>
            <div class="text-lg font-semibold mt-4 mb-4">ข้อมูลภาษาไทย</div>
            <div class="grid grid-cols-12 gap-4">
              <template v-if="type == 'C'">
                <div class="col-span-12 md:col-span-5">
                  <breeze-label for="owner_firstname" value="ชื่อนิติบุคคล (กรอกแบบเต็ม เช่น บริษัท ดีบีดี จำกัด)*" />
                  <breeze-input
                    id="owner_firstname"
                    type="text"
                    class="mt-1 block w-full"
                    placeholder="เช่น บริษัท ดีบีดี จำกัด, ห้างหุ้นส่วนจำกัด ดีบีดี"
                    v-model="form.owner_firstname"
                  />
                  <breeze-input-error
                    :message="form.errors.owner_firstname"
                    class="mt-2"
                  />
                </div>

                <div class="col-span-12 md:col-span-3">
                  <breeze-label for="owner_title_code" value="ประเภท*" />
                  <select
                    v-model="form.owner_title_code"
                    class="
                      w-full
                      mt-1
                      border-gray-300
                      focus:border-indigo-300
                      focus:ring focus:ring-indigo-200 focus:ring-opacity-50
                      rounded-md
                      shadow-sm
                    "
                    @change="completeJuristicTitle()"
                  >
                    <option :value="null" disabled>-- เลือกประเภท --</option>
                    <option
                      v-for="(juristicTitle, index) in juristicTitles"
                      :key="`jt-${index}`"
                      :value="juristicTitle.titleid"
                    >
                      {{ juristicTitle.titleth }}
                    </option>
                  </select>
                  <breeze-input-error
                    :message="form.errors.owner_title_code"
                    class="mt-2"
                  />
                </div>

                <div class="col-span-8 sm:col-span-2">
                  <breeze-label for="owner_branch_name" value="ชื่อสาขา" />
                  <breeze-input
                    id="owner_branch_name"
                    type="text"
                    class="mt-1 block w-full"
                    placeholder="เช่น สำนักงานใหญ่"
                    v-model="form.owner_branch_name"
                  />
                  <breeze-input-error
                    :message="form.errors.owner_branch_name"
                    class="mt-2"
                  />
                </div>

                <div class="col-span-4 sm:col-span-2">
                  <breeze-label for="branch_no" value="สาขาที่" />
                  <breeze-input
                    id="branch_no"
                    type="text"
                    class="mt-1 block w-full"
                    placeholder="เช่น 00000"
                    v-model="form.branch_no"
                  />
                  <breeze-input-error
                    :message="form.errors.branch_no"
                    class="mt-2"
                  />
                </div>
              </template>
              <template v-else>
                <div class="col-span-4 md:col-span-3">
                  <breeze-label
                    for="owner_title_code"
                    value="ชื่อผู้ประกอบการ (คำนำหน้า)*"
                  />
                  <select
                    v-model="form.owner_title_code"
                    class="
                      w-full
                      mt-1
                      border-gray-300
                      focus:border-indigo-300
                      focus:ring focus:ring-indigo-200 focus:ring-opacity-50
                      rounded-md
                      shadow-sm
                    "
                    @change="selectedOwnerTitle()"
                  >
                    <option :value="null" disabled>-- เลือก --</option>
                    <option
                      v-for="(personTitle, index) in personTitles"
                      :key="`jt-${index}`"
                      :value="personTitle.titleid"
                    >
                      {{ personTitle.titleth }}
                    </option>
                  </select>
                  <breeze-input-error
                    :message="form.errors.owner_title_code"
                    class="mt-2"
                  />
                </div>

                <div class="col-span-8 md:col-span-3">
                  <breeze-label
                    for="owner_firstname"
                    value="ชื่อผู้ประกอบการ (ชื่อ)*"
                  />
                  <breeze-input
                    id="owner_firstname"
                    type="text"
                    class="mt-1 block w-full"
                    placeholder="เช่น สมหวัง"
                    v-model="form.owner_firstname"
                  />
                  <breeze-input-error
                    :message="form.errors.owner_firstname"
                    class="mt-2"
                  />
                </div>

                <div class="col-span-12 md:col-span-3">
                  <breeze-label
                    for="owner_lastname"
                    value="ชื่อผู้ประกอบการ (นามสกุล)*"
                  />
                  <breeze-input
                    id="owner_lastname"
                    type="text"
                    class="mt-1 block w-full"
                    placeholder="เช่น พัฒนาการค้า"
                    v-model="form.owner_lastname"
                  />
                  <breeze-input-error
                    :message="form.errors.owner_lastname"
                    class="mt-2"
                  />
                </div>
              </template>

              <div class="col-span-12 sm:col-span-3">
                <breeze-label
                  for="tax_id"
                  value="เลขประจำตัวผู้เสียภาษีอากร 13 หลัก*"
                />
                <breeze-input
                  id="tax_id"
                  type="text"
                  class="mt-1 block w-full"
                  v-model="form.tax_id"
                />
                <breeze-input-error
                  :message="form.errors.tax_id"
                  class="mt-2"
                />
              </div>

              <div class="col-span-4 md:col-span-3">
                <breeze-label
                  for="manager_title_code"
                  value="ชื่อผู้ติดต่อ (คำนำหน้า)*"
                />
                <select
                  v-model="form.manager_title_code"
                  class="
                    w-full
                    mt-1
                    border-gray-300
                    focus:border-indigo-300
                    focus:ring focus:ring-indigo-200 focus:ring-opacity-50
                    rounded-md
                    shadow-sm
                  "
                  @change="completePersonTitle()"
                >
                  <option :value="null" disabled>-- เลือก --</option>
                  <option
                    v-for="(personTitle, index) in personTitles"
                    :key="`jt-${index}`"
                    :value="personTitle.titleid"
                  >
                    {{ personTitle.titleth }}
                  </option>
                </select>
                <breeze-input-error
                  :message="form.errors.manager_title_code"
                  class="mt-2"
                />
              </div>

              <div class="col-span-8 md:col-span-3">
                <breeze-label
                  for="manager_firstname"
                  value="ชื่อผู้ติดต่อ (ชื่อ)*"
                />
                <breeze-input
                  id="manager_firstname"
                  type="text"
                  class="mt-1 block w-full"
                  placeholder="เช่น สมชาย"
                  v-model="form.manager_firstname"
                />
                <breeze-input-error
                  :message="form.errors.manager_firstname"
                  class="mt-2"
                />
              </div>

              <div class="col-span-12 md:col-span-3">
                <breeze-label
                  for="manager_lastname"
                  value="ชื่อผู้ติดต่อ (นามสกุล)*"
                />
                <breeze-input
                  id="manager_lastname"
                  type="text"
                  class="mt-1 block w-full"
                  placeholder="เช่น ส่งเสริมพาณิชย์"
                  v-model="form.manager_lastname"
                />
                <breeze-input-error
                  :message="form.errors.manager_lastname"
                  class="mt-2"
                />
              </div>

              <div v-if="type == 'P'" class="col-span-12 md:col-span-3">
                <breeze-label for="company_name" value="ชื่อกิจการ/ร้านค้า*" />
                <breeze-input
                  id="company_name"
                  type="text"
                  class="mt-1 block w-full"
                  placeholder="เช่น ร้านต้นไม้สมหวัง"
                  v-model="form.company_name"
                />
                <breeze-input-error
                  :message="form.errors.company_name"
                  class="mt-2"
                />
              </div>
            </div>

            <div class="text-lg font-semibold mt-8 mb-4">ที่อยู่ภาษาไทย</div>
            <div class="grid grid-cols-12 gap-4">
              <div class="col-span-4 sm:col-span-2">
                <breeze-label for="house_no" value="เลขที่*" />
                <breeze-input
                  id="house_no"
                  type="text"
                  class="mt-1 block w-full"
                  v-model="form.house_no"
                  @keyup="completeHouseNo"
                />
                <breeze-input-error
                  :message="form.errors.house_no"
                  class="mt-2"
                />
              </div>

              <div class="col-span-8 sm:col-span-3">
                <breeze-label for="building" value="อาคาร/หมู่บ้าน" />
                <breeze-input
                  id="building"
                  type="text"
                  class="mt-1 block w-full"
                  v-model="form.building"
                />
                <breeze-input-error
                  :message="form.errors.building"
                  class="mt-2"
                />
              </div>

              <div class="col-span-6 sm:col-span-1">
                <breeze-label for="floor" value="ชั้น" />
                <breeze-input
                  id="floor"
                  type="text"
                  class="mt-1 block w-full"
                  v-model="form.floor"
                  @keyup="completeFloor"
                />
                <breeze-input-error :message="form.errors.floor" class="mt-2" />
              </div>

              <div class="col-span-6 sm:col-span-1">
                <breeze-label for="moo" value="หมู่ที่" />
                <breeze-input
                  id="moo"
                  type="text"
                  class="mt-1 block w-full"
                  v-model="form.moo"
                  @keyup="completeMoo"
                />
                <breeze-input-error :message="form.errors.moo" class="mt-2" />
              </div>

              <div class="col-span-6 sm:col-span-2">
                <breeze-label for="soi" value="ซอย" />
                <breeze-input
                  id="soi"
                  type="text"
                  class="mt-1 block w-full"
                  v-model="form.soi"
                />
                <breeze-input-error :message="form.errors.soi" class="mt-2" />
              </div>

              <div class="col-span-6 sm:col-span-3">
                <breeze-label for="road" value="ถนน" />
                <breeze-input
                  id="road"
                  type="text"
                  class="mt-1 block w-full"
                  v-model="form.road"
                />
                <breeze-input-error :message="form.errors.road" class="mt-2" />
              </div>

              <div class="col-span-6 sm:col-span-3">
                <breeze-label for="province_code" value="จังหวัด*" />
                <select
                  v-model="form.province_code"
                  class="
                    w-full
                    mt-1
                    border-gray-300
                    focus:border-indigo-300
                    focus:ring focus:ring-indigo-200 focus:ring-opacity-50
                    rounded-md
                    shadow-sm
                  "
                  @change="getDistrict"
                >
                  <option :value="null" disabled>-- เลือกจังหวัด --</option>
                  <option
                    v-for="(province, index) in provinces"
                    :key="`ct-${index}`"
                    :value="province.province_code"
                  >
                    {{ province.province_th }}
                  </option>
                </select>
                <breeze-input-error
                  :message="form.errors.province_code"
                  class="mt-2"
                />
              </div>

              <div class="col-span-6 sm:col-span-3">
                <breeze-label for="district_code" value="อำเภอ/เขต*" />
                <select
                  v-model="form.district_code"
                  class="
                    w-full
                    mt-1
                    border-gray-300
                    focus:border-indigo-300
                    focus:ring focus:ring-indigo-200 focus:ring-opacity-50
                    rounded-md
                    shadow-sm
                  "
                  @change="getSubDistrict"
                >
                  <option :value="null" disabled>-- เลือกอำเภอ/เขต--</option>
                  <option
                    v-for="(district, index) in districts"
                    :key="`ct-${index}`"
                    :value="district.district_code"
                  >
                    {{ district.district_th }}
                  </option>
                </select>
                <breeze-input-error
                  :message="form.errors.district_code"
                  class="mt-2"
                />
              </div>

              <div class="col-span-6 sm:col-span-3">
                <breeze-label for="sub_district_code" value="ตำบล/แขวง*" />
                <select
                  v-model="form.sub_district_code"
                  class="
                    w-full
                    mt-1
                    border-gray-300
                    focus:border-indigo-300
                    focus:ring focus:ring-indigo-200 focus:ring-opacity-50
                    rounded-md
                    shadow-sm
                  "
                  @change="getPostalCode"
                >
                  <option :value="null" disabled>-- เลือกตำบล/แขวง--</option>
                  <option
                    v-for="(subDistrict, index) in subDistricts"
                    :key="`ct-${index}`"
                    :value="subDistrict.sub_district_code"
                  >
                    {{ subDistrict.sub_district_th }}
                  </option>
                </select>
                <breeze-input-error
                  :message="form.errors.sub_district_code"
                  class="mt-2"
                />
              </div>

              <div class="col-span-6 sm:col-span-3">
                <breeze-label for="post_code" value="รหัสไปรษณีย์*" />
                <breeze-input
                  id="post_code"
                  type="text"
                  class="mt-1 block w-full"
                  v-model="form.post_code"
                />
                <breeze-input-error
                  :message="form.errors.post_code"
                  class="mt-2"
                />
              </div>

              <div class="col-span-12 sm:col-span-3">
                <breeze-label for="email" value="อีเมล*" />
                <breeze-input
                  id="email"
                  type="text"
                  class="mt-1 block w-full"
                  v-model="form.email"
                />
                <breeze-input-error :message="form.errors.email" class="mt-2" />
              </div>

              <div class="col-span-12 sm:col-span-3">
                <breeze-label
                  for="telephone"
                  value="เบอร์โทรศัพท์/เบอร์มือถือ*"
                />
                <breeze-input
                  id="telephone"
                  type="text"
                  class="mt-1 block w-full"
                  v-model="form.telephone"
                />
                <breeze-input-error
                  :message="form.errors.telephone"
                  class="mt-2"
                />
              </div>
            </div>

            <div class="text-lg font-semibold mt-8 mb-4">ข้อมูลภาษาอังกฤษ</div>
            <div class="grid grid-cols-12 gap-4">
              <template v-if="type == 'C'">
                <div class="col-span-12 md:col-span-5">
                  <breeze-label
                    for="owner_firstname_en"
                    value="Company Name (กรอกแบบเต็ม เช่น DBD Co., Ltd.)*"
                  />
                  <breeze-input
                    id="owner_firstname_en"
                    type="text"
                    class="mt-1 block w-full"
                    placeholder="เช่น DBD Co., Ltd., DBD Part., Ltd."
                    v-model="form.owner_firstname_en"
                  />
                  <breeze-input-error
                    :message="form.errors.owner_firstname_en"
                    class="mt-2"
                  />
                </div>

                <div class="col-span-12 md:col-span-3">
                  <breeze-label for="owner_title_en" value="Juristic Type*" />
                  <div
                    class="
                      mt-1
                      px-3
                      py-2
                      h-10
                      font-medium
                      bg-blue-50
                      border-gray-300
                      rounded-md
                      shadow-sm
                      text-gray-700
                    "
                  >
                    {{ form.owner_title_en }}
                  </div>
                </div>

                <div class="col-span-8 sm:col-span-2">
                  <breeze-label
                    for="owner_branch_name_en"
                    value="Branch Name"
                  />
                  <breeze-input
                    id="owner_branch_name_en"
                    type="text"
                    class="mt-1 block w-full"
                    placeholder="เช่น HQ"
                    v-model="form.owner_branch_name_en"
                  />
                  <breeze-input-error
                    :message="form.errors.owner_branch_name_en"
                    class="mt-2"
                  />
                </div>

                <div class="col-span-4 sm:col-span-2">
                  <breeze-label for="branch_no" value="Branch No." />
                  <div
                    class="
                      mt-1
                      px-3
                      py-2
                      h-10
                      font-medium
                      bg-blue-50
                      border-gray-300
                      rounded-md
                      shadow-sm
                      text-gray-700
                    "
                  >
                    {{ form.branch_no }}
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="col-span-12 md:col-span-3">
                  <breeze-label for="owner_title_en" value="Owner (title)*" />
                  <div
                    class="
                      mt-1
                      px-3
                      py-2
                      h-10
                      font-medium
                      bg-blue-50
                      border-gray-300
                      rounded-md
                      shadow-sm
                      text-gray-700
                    "
                  >
                    {{ form.owner_title_en }}
                  </div>
                </div>

                <div class="col-span-8 md:col-span-3">
                  <breeze-label
                    for="owner_firstname_en"
                    value="Owner (firstname)*"
                  />
                  <breeze-input
                    id="owner_firstname_en"
                    type="text"
                    class="mt-1 block w-full"
                    placeholder="เช่น Somwang"
                    v-model="form.owner_firstname_en"
                  />
                  <breeze-input-error
                    :message="form.errors.owner_firstname_en"
                    class="mt-2"
                  />
                </div>

                <div class="col-span-12 md:col-span-3">
                  <breeze-label
                    for="owner_lastname_en"
                    value="Owner (lastname)*"
                  />
                  <breeze-input
                    id="owner_lastname_en"
                    type="text"
                    class="mt-1 block w-full"
                    placeholder="เช่น Pattanakarnka"
                    v-model="form.owner_lastname_en"
                  />
                  <breeze-input-error
                    :message="form.errors.owner_lastname_en"
                    class="mt-2"
                  />
                </div>
              </template>

              <div class="col-span-12 sm:col-span-3">
                <breeze-label for="tax_id" value="Tax ID (13 Digits)*" />
                <div
                  class="
                    mt-1
                    px-3
                    py-2
                    h-10
                    font-medium
                    bg-blue-50
                    border-gray-300
                    rounded-md
                    shadow-sm
                    text-gray-700
                  "
                >
                  {{ form.tax_id }}
                </div>
              </div>

              <div class="col-span-4 md:col-span-3">
                <breeze-label
                  for="manager_title_en"
                  value="Contact Person (title)*"
                />
                <div
                  class="
                    mt-1
                    px-3
                    py-2
                    h-10
                    font-medium
                    bg-blue-50
                    border-gray-300
                    rounded-md
                    shadow-sm
                    text-gray-700
                  "
                >
                  {{ form.manager_title_en }}
                </div>
              </div>

              <div class="col-span-8 md:col-span-3">
                <breeze-label
                  for="manager_firstname_en"
                  value="Contact Person (firstname)*"
                />
                <breeze-input
                  id="manager_firstname_en"
                  type="text"
                  class="mt-1 block w-full"
                  placeholder="เช่น Somchai"
                  v-model="form.manager_firstname_en"
                />
                <breeze-input-error
                  :message="form.errors.manager_firstname_en"
                  class="mt-2"
                />
              </div>

              <div class="col-span-12 md:col-span-3">
                <breeze-label
                  for="manager_lastname_en"
                  value="Contact Person (lastname)*"
                />
                <breeze-input
                  id="manager_lastname_en"
                  type="text"
                  class="mt-1 block w-full"
                  placeholder="เช่น SongsermPanij"
                  v-model="form.manager_lastname_en"
                />
                <breeze-input-error
                  :message="form.errors.manager_lastname_en"
                  class="mt-2"
                />
              </div>

              <div v-if="type == 'P'" class="col-span-12 md:col-span-3">
                <breeze-label for="company_name_en" value="Business Name/Shop Name*" />
                <breeze-input
                  id="company_name_en"
                  type="text"
                  class="mt-1 block w-full"
                  placeholder="เช่น Somwang Plant"
                  v-model="form.company_name_en"
                />
                <breeze-input-error
                  :message="form.errors.company_name_en"
                  class="mt-2"
                />
              </div>
            </div>

            <div class="text-lg font-semibold mt-8 mb-4">ที่อยู่ภาษาอังกฤษ</div>
            <div class="grid grid-cols-12 gap-4">
              <div class="col-span-4 sm:col-span-2">
                <breeze-label for="house_no_en" value="House No.*" />
                <div
                  class="
                    mt-1
                    px-3
                    py-2
                    h-10
                    font-medium
                    bg-blue-50
                    border-gray-300
                    rounded-md
                    shadow-sm
                    text-gray-700
                  "
                >
                  {{ form.house_no_en }}
                </div>
              </div>

              <div class="col-span-8 sm:col-span-3">
                <breeze-label for="building_en" value="Building/Village" />
                <breeze-input
                  id="building_en"
                  type="text"
                  class="mt-1 block w-full"
                  v-model="form.building_en"
                />
                <breeze-input-error
                  :message="form.errors.building_en"
                  class="mt-2"
                />
              </div>

              <div class="col-span-6 sm:col-span-1">
                <breeze-label for="floor_en" value="Floor" />
                <div
                  class="
                    mt-1
                    px-3
                    py-2
                    h-10
                    font-medium
                    bg-blue-50
                    border-gray-300
                    rounded-md
                    shadow-sm
                    text-gray-700
                  "
                >
                  {{ form.floor_en }}
                </div>
              </div>

              <div class="col-span-6 sm:col-span-1">
                <breeze-label for="moo_en" value="Moo" />
                <div
                  class="
                    mt-1
                    px-3
                    py-2
                    h-10
                    font-medium
                    bg-blue-50
                    border-gray-300
                    rounded-md
                    shadow-sm
                    text-gray-700
                  "
                >
                  {{ form.moo_en }}
                </div>
              </div>

              <div class="col-span-6 sm:col-span-2">
                <breeze-label for="soi_en" value="Soi" />
                <breeze-input
                  id="soi_en"
                  type="text"
                  class="mt-1 block w-full"
                  v-model="form.soi_en"
                />
                <breeze-input-error
                  :message="form.errors.soi_en"
                  class="mt-2"
                />
              </div>

              <div class="col-span-6 sm:col-span-3">
                <breeze-label for="road_en" value="Road" />
                <breeze-input
                  id="road_en"
                  type="text"
                  class="mt-1 block w-full"
                  v-model="form.road_en"
                />
                <breeze-input-error
                  :message="form.errors.road_en"
                  class="mt-2"
                />
              </div>

              <div class="col-span-6 sm:col-span-3">
                <breeze-label value="Province*" />
                <div
                  class="
                    mt-1
                    px-3
                    py-2
                    h-10
                    font-medium
                    bg-blue-50
                    border-gray-300
                    rounded-md
                    shadow-sm
                    text-gray-700
                  "
                >
                  {{ form.province_name_en }}
                </div>
              </div>

              <div class="col-span-6 sm:col-span-3">
                <breeze-label value="District*" />
                <div
                  class="
                    mt-1
                    px-3
                    py-2
                    h-10
                    font-medium
                    bg-blue-50
                    border-gray-300
                    rounded-md
                    shadow-sm
                    text-gray-700
                  "
                >
                  {{ form.district_name_en }}
                </div>
              </div>

              <div class="col-span-6 sm:col-span-3">
                <breeze-label value="Sub District*" />
                <div
                  class="
                    mt-1
                    px-3
                    py-2
                    h-10
                    font-medium
                    bg-blue-50
                    border-gray-300
                    rounded-md
                    shadow-sm
                    text-gray-700
                  "
                >
                  {{ form.sub_district_name_en }}
                </div>
              </div>

              <div class="col-span-6 sm:col-span-3">
                <breeze-label value="Postal Code*" />
                <div
                  class="
                    mt-1
                    px-3
                    py-2
                    h-10
                    font-medium
                    bg-blue-50
                    border-gray-300
                    rounded-md
                    shadow-sm
                    text-gray-700
                  "
                >
                  {{ form.post_code }}
                </div>
              </div>
            </div>

            <div class="text-lg font-semibold mt-8 mb-4">ข้อมูลอื่น ๆ</div>
            <div class="grid grid-cols-12 gap-4">
              <div class="col-span-12">
                <breeze-label
                  for="commercial_type_code"
                  value="ลักษณะของกิจการ*"
                />
                <select
                  v-model="form.commercial_type_code"
                  class="
                    w-full
                    mt-1
                    border-gray-300
                    focus:border-indigo-300
                    focus:ring focus:ring-indigo-200 focus:ring-opacity-50
                    rounded-md
                    shadow-sm
                  "
                >
                  <option :value="null" disabled>
                    -- เลือกลักษณะของกิจการ --
                  </option>
                  <option
                    v-for="(commercialType, index) in commercialTypes"
                    :key="`ct-${index}`"
                    :value="commercialType.businesstypeid"
                  >
                    {{ commercialType.businesstypeth }}
                  </option>
                </select>
                <breeze-input-error
                  :message="form.errors.commercial_type_code"
                  class="mt-2"
                />
              </div>

              <div class="col-span-12 sm:col-span-6">
                <breeze-label
                  class="mb-2"
                  for="payment_type_codes"
                  value="วิธีการชำระเงินของสินค้าและ/หรือบริการ*"
                />
                <label
                  class="block"
                  v-for="(paymentType, index) in paymentTypes"
                  :key="`pt-${index}`"
                >
                  <breeze-checkbox
                    :value="paymentType.paymenttypeid"
                    v-model:checked="form.payment_type_codes"
                  />
                  <span class="ml-2 text-sm text-gray-600">{{
                    paymentType.paymenttypeth
                  }}</span>
                </label>
                <breeze-input-error
                  :message="form.errors.payment_type_codes"
                  class="mt-2"
                />
              </div>

              <div class="col-span-12 sm:col-span-3">
                <breeze-label
                  class="mb-2"
                  for="reserve_type_codes"
                  value="วิธีการสั่งจองสินค้าและ/หรือบริการ*"
                />
                <label
                  class="block"
                  v-for="(reserveType, index) in reserveTypes"
                  :key="`rt-${index}`"
                >
                  <breeze-checkbox
                    :value="reserveType.reservetypeid"
                    v-model:checked="form.reserve_type_codes"
                  />
                  <span class="ml-2 text-sm text-gray-600">{{
                    reserveType.reservetypeth
                  }}</span>
                </label>
                <breeze-input-error
                  :message="form.errors.reserve_type_codes"
                  class="mt-2"
                />
              </div>

              <div class="col-span-12 sm:col-span-3">
                <breeze-label
                  class="mb-2"
                  for="delivery_type_codes"
                  value="วิธีการส่งสินค้าและ/หรือบริการ*"
                />
                <label
                  class="block"
                  v-for="(deliveryType, index) in deliveryTypes"
                  :key="`rt-${index}`"
                >
                  <breeze-checkbox
                    :value="deliveryType.deliverytypeid"
                    v-model:checked="form.delivery_type_codes"
                  />
                  <span class="ml-2 text-sm text-gray-600">{{
                    deliveryType.deliverytypeth
                  }}</span>
                </label>
                <breeze-input-error
                  :message="form.errors.delivery_type_codes"
                  class="mt-2"
                />
              </div>
              <div class="col-span-6 sm:col-span-3">
                <breeze-label
                  for="referral_code"
                  value="Referral Code (ถ้ามี)"
                />
                <breeze-input
                    id="referral_code"
                    type="text"
                    class="mt-1 block w-full"
                    v-model="form.referral_code"
                  />
                  <breeze-input-error
                    :message="form.errors.referral_code"
                    class="mt-2"
                  />
              </div>
            </div>
            
          </div>

          <div class="grid bg-blue-50 border-t border-gray-200">
            <div class="p-6">
              <div class="text-blue-900 text-center text-xl font-semibold mb-4">
                <span class="text-yellow-500">Step 3</span> :
                เลือกความต้องการเพิ่มเติมเพิ่มจากเว็บไซต์/โดเมน
              </div>
              <label class="block">
                <breeze-checkbox
                  name="need_sale_page"
                  v-model:checked="form.need_sale_page"
                  @click="salePageUpdated()"
                />
                <span class="ml-2 text-sm text-gray-600"
                  >ประสงค์จะขอ Web Site ฟรีของชื่อโดเมนที่จดทะเบียน
                  </span
                >
              </label>
              <label v-for="(vendor, key) in vendors.data" class="block" v-show="form.need_sale_page" :key="key">
                <input type="radio" name="layout" v-model="form.package_id" class="ml-4" :value="vendor.id" 
                  >
                <span class="ml-2 text-sm text-gray-600" 
                  >{{vendor.name}} โดย {{vendor.vendor_name}}</span>
              </label>
              <label class="block">
                <breeze-checkbox
                  name="need_dbd_registered"
                  v-model:checked="form.need_dbd_registered"
                />
                <span class="ml-2 text-sm text-gray-600"
                  >ประสงค์จะขอเครื่องหมายรับรองผู้ประกอบธุรกิจพาณิชย์อิเล็กทรอนิกส์
                  (DBD Registered) สำหรับชื่อเว็บไซต์/โดเมนที่ขอจดทะเบียน</span
                >
              </label>
              <label class="block">
                <breeze-checkbox
                  name="need_membership"
                  v-model:checked="form.need_membership"
                />
                <span class="ml-2 text-sm text-gray-600"
                  >ประสงค์จะสมัครสมาชิกวิสามัญสมาคมของโครงการ
                  (สมาคมผู้ดูแลเว็บไซต์และสื่อออนไลน์ไทย
                  และ สมาคมผู้ประกอบการพาณิชย์อิเล็กทรอนิกส์ไทย
                  )</span
                >
              </label>
              <label class="block">
                <breeze-checkbox
                  name="can_promote"
                  v-model:checked="form.can_promote"
                />
                <span class="ml-2 text-sm text-gray-600"
                  >ยินยอมให้โครงการฯนำชื่อเว็บไซต์/โดเมนและเว็บไซต์ของท่าน(หากมี) ไปประชาสัมพันธ์ให้กับสาธารณะบนเว็บไซต์ของโครงการฯ</span
                >
              </label>
            </div>
          </div>
          <div class="grid grid-cols-1 md:grid-cols-2 border-t border-gray-200">
            <div class="p-6">
              <div class="flex items-center">
                <svg
                  fill="none"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  viewBox="0 0 24 24"
                  class="w-8 h-8 text-gray-500"
                >
                  <path
                    d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
                  ></path>
                </svg>
                <div class="ml-4 text-lg leading-7 font-semibold">
                  <span class="text-blue-900">ข้อกำหนดและเงื่อนไข</span>
                </div>
              </div>

              <div class="ml-12">
                <div class="mt-2 text-gray-600 text-sm">
                  <ul class="mt-2 ml-3 list-outside list-disc">
                    <li>สามารถจดทะเบียนเว็บไซต์/โดเมนได้เพียง 1 ชื่อเท่านั้น</li>
                    <li>
                      สำหรับเว็บไซต์ฟรี 1 หน้า ทางโครงการฯ
                      มีระบบจัดการที่สามารถปรับแต่งหน้าตาของเว็บไซต์
                      โดยท่านจะได้รับบัญชีเข้าสู่ระบบฯ
                      หลังจากที่ทางมูลนิธิฯอนุมัติการจดทะเบียนเว็บไซต์/โดเมนของท่านแล้ว
                    </li>
                    <li>
                      หากท่านไม่ต้องการใช้เว็บไซต์ที่ทางโครงการจัดเตรียมให้ท่านสามารถทำการตั้งค่าเว็บไซต์/โดเมนของท่านไปยัง
                      web hosting ที่ท่านได้จัดเตรียมไว้ได้
                    </li>
                    <li v-if="type == 'C'">
                      สำหรับเว็บไซต์/โดเมน .co.th ชื่อเว็บไซต์/โดเมนจำเป็นต้องสอดคล้อง,
                      เป็นส่วนใดส่วนหนึ่ง หรือย่อมาจากชื่อองค์กรเท่านั้น
                    </li>
                    <li>
                      มูลนิธิฯขอสงวนสิทธิ์การปฏิเสธการจดทะเบียนชื่อเว็บไซต์/โดเมนที่ไม่เป็นไปตามเงื่อนไขข้างต้น
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="p-6 border-t border-gray-200 md:border-t-0 md:border-l">
              <div class="flex items-center">
                <svg
                  fill="none"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  viewBox="0 0 24 24"
                  class="w-8 h-8 text-gray-500"
                >
                  <path
                    d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  ></path>
                </svg>
                <div class="ml-4 text-lg leading-7 font-semibold">
                  <span class="text-blue-900"
                    >สิ่งที่จะได้รับหลังจากลงทะเบียน</span
                  >
                </div>
              </div>

              <div class="ml-12">
                <div class="mt-2 text-gray-600 text-sm">
                  หลังจากที่มูลนิธิฯ
                  ตรวจสอบข้อมูลนิติบุคคลกับกรมพัฒนาธุรกิจการค้าเรียบร้อย
                  และส่งจดทะเบียนชื่อเว็บไซต์/โดเมนสำเร็จ ท่านจะได้รับ
                  <ul class="mt-2 ml-3 list-outside list-disc">
                    <li>อีเมลสำหรับจัดการตั้งค่าเว็บไซต์/โดเมน</li>
                    <li>อีเมลสำหรับจัดการตั้งค่าเว็บไซต์</li>
                    <li>
                      เครื่องหมาย DBD Registered (หากท่านแจ้งความประสงค์ไว้)
                      หลังจากที่กรมพัฒนาธุรกิจการค้าได้พิจารณาใบสมัครของท่านแล้ว
                      ทางกรมฯ จะแจ้ง code
                      สำหรับติดตั้งเครื่องหมายบนหน้าเว็บไซต์ให้กับท่านทางอีเมลที่ลงทะเบียนไว้
                    </li>
                    <li>
                      เป็นสมาชิกของสมาคมต่าง ๆ ที่ระบุไว้ในโครงการ เป็นเวลา 1 ปี
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="md:col-span-2 p-6 border-t border-gray-200 text-center">
              <div classs="flex items-center justify-center">
                <label>
                  <breeze-checkbox
                    name="isAgreedOnTerm"
                    v-model:checked="isAgreedOnTerm"
                  />
                  <span class="ml-2 text-sm text-gray-600"
                    >ข้าพเจ้าได้อ่านและยอมรับเงื่อนไขของโครงการข้างต้นแล้ว</span
                  >
                </label>
              </div>
              <button
                class="
                  mt-4
                  px-4
                  py-2
                  bg-blue-900
                  border border-transparent
                  rounded-md
                  text-xl text-white
                  tracking-widest
                  hover:bg-yellow-600
                  active:bg-yellow-700
                  focus:outline-none
                  focus:border-yellow-700
                  focus:shadow-outline-white
                  transition
                  ease-in-out
                  duration-150
                "
                :class="{
                  'opacity-50': form.processing || !isAgreedOnTerm,
                }"
                :disabled="form.processing || !isAgreedOnTerm"
              >
                ลงทะเบียนเข้าร่วมโครงการ
              </button>
            </div>
          </div>
        </form>
      </div>

      <div class="my-4 grid grid-cols-1 md:grid-cols-2">
        <div class="text-sm text-center md:text-left text-gray-500">
          <a href="https://thaionline.in.th" class="ml-1 underline">
            หน้าหลักของโครงการ
          </a>
        </div>

        <div
          class="
            mt-3
            md:mt-0
            text-sm text-center
            md:text-right
            text-gray-500
            sm:ml-0
          "
        >
          โครงการส่งเสริมธุรกิจไทยใช้พาณิชย์อิเล็กทรอนิกส์
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BreezeCheckbox from "@/Components/Checkbox";
import BreezeLabel from "@/Components/Label";
import BreezeInput from "@/Components/Input";
import BreezeInputError from "@/Components/InputError";
import { replace } from "lodash";

export default {
  props: ["type", "vendors"],
  components: {
    BreezeCheckbox,
    BreezeLabel,
    BreezeInput,
    BreezeInputError,
  },
  data() {
    return {
      tlds:
        this.type == "C"
          ? [".co.th", ".in.th"]
          : [".in.th"],

      commercialTypes: [],
      deliveryTypes: [],
      districts: [],
      juristicTitles: [],
      paymentTypes: [],
      personTitles: [],
      provinces: [],
      reserveTypes: [],
      subDistricts: [],

      form: this.$inertia.form({
        domain_name: null,
        domain: null,
        tld: this.type == "C" ? ".co.th" : ".in.th",
        tax_id: null,
        branch_no: null,
        email: null,
        type: this.type,
        telephone: null,
        referral_code: null,
        owner_title_code: null,
        owner_title: null,
        owner_firstname: null,
        owner_lastname: null,
        owner_branch_name: null,
        owner_title_en: null,
        owner_firstname_en: null,
        owner_lastname_en: null,
        owner_branch_name_en: null,
        company_name: null,
        company_name_en: null,
        manager_title_code: null,
        manager_title: null,
        manager_firstname: null,
        manager_lastname: null,
        manager_title_en: null,
        manager_firstname_en: null,
        manager_lastname_en: null,
        house_no: null,
        building: null,
        floor: null,
        moo: null,
        soi: null,
        road: null,
        house_no_en: null,
        building_en: null,
        floor_en: null,
        moo_en: null,
        soi_en: null,
        road_en: null,
        sub_district_code: null,
        sub_district_name: null,
        sub_district_name_en: null,
        district_code: null,
        district_name: null,
        district_name_en: null,
        province_code: null,
        province_name: null,
        province_name_en: null,
        post_code: null,
        commercial_type_code: null,
        payment_type_codes: [],
        reserve_type_codes: [],
        delivery_type_codes: [],
        need_dbd_registered: true,
        need_membership: true,
        need_website: false,
        need_sale_page: true,
        vendor_id: 1,
        package_id: 1,
        need_packages: false,
        can_promote: true,
        need_guestbook: false,
      }),
      isAgreedOnTerm: false,
      isOpenNextSteps: false,
      isChecking: false,
      domainResult: null,
    };
  },
  created() {
    //load master
    axios
      .all([
        axios.get(route("master_data.commercial_types")),
        axios.get(route("master_data.delivery_types")),
        axios.get(route("master_data.juristic_titles")),
        axios.get(route("master_data.payment_types")),
        axios.get(route("master_data.person_titles")),
        axios.get(route("master_data.provinces")),
        axios.get(route("master_data.reserve_types")),
      ])
      .then(
        axios.spread(
          (
            commercialTypesRes,
            deliveryTypesRes,
            juristicTitlesRes,
            paymentTypesRes,
            personTitlesRes,
            provincesRes,
            reserveTypesRes
          ) => {
            this.commercialTypes = commercialTypesRes.data;
            this.deliveryTypes = deliveryTypesRes.data;
            this.juristicTitles = juristicTitlesRes.data;
            this.paymentTypes = paymentTypesRes.data;
            this.personTitles = personTitlesRes.data;
            this.provinces = provincesRes.data;
            this.reserveTypes = reserveTypesRes.data;
          }
        )
      );
  },
  methods: {
    salePageUpdated() {
      if (this.form.need_sale_page == false)
        this.form.vendor_id = 1;
        this.form.package_id = 1;
    },
    completeJuristicTitle() {
      let selectedJuristicTitle = _.find(
        this.juristicTitles,
        (juristicTitle) => juristicTitle.titleid == this.form.owner_title_code
      );
      this.form.owner_title = selectedJuristicTitle.titleth;
      this.form.owner_title_en = selectedJuristicTitle.titleen;
    },
    selectedOwnerTitle() {
      let selectedOwnerTitle = _.find(
        this.personTitles,
        (personTitle) => personTitle.titleid == this.form.owner_title_code
      );
      this.form.owner_title = selectedOwnerTitle.titleth;
      this.form.owner_title_en = selectedOwnerTitle.titleen;
    },
    completePersonTitle() {
      let selectedPersonTitle = _.find(
        this.personTitles,
        (personTitle) => personTitle.titleid == this.form.manager_title_code
      );
      this.form.manager_title = selectedPersonTitle.titleth;
      this.form.manager_title_en = selectedPersonTitle.titleen;
    },
    completeHouseNo() {
      this.form.house_no_en = this.form.house_no;
    },
    completeFloor() {
      this.form.floor_en = this.form.floor;
    },
    completeMoo() {
      this.form.moo_en = this.form.moo;
    },
    getDistrict() {
      let selectedProvince = _.find(
        this.provinces,
        (province) => province.province_code == this.form.province_code
      );
      this.form.province_name = selectedProvince.province_th;
      this.form.province_name_en = selectedProvince.province_en;
      axios
        .get(
          route("master_data.districts", {
            provinceCode: this.form.province_code,
          })
        )
        .then((response) => (this.districts = response.data));
    },
    getSubDistrict() {
      let selectedDistrict = _.find(
        this.districts,
        (district) => district.district_code == this.form.district_code
      );
      this.form.district_name = selectedDistrict.district_th;
      this.form.district_name_en = selectedDistrict.district_en;
      axios
        .get(
          route("master_data.sub_districts", {
            provinceCode: this.form.province_code,
            districtCode: this.form.district_code,
          })
        )
        .then((response) => (this.subDistricts = response.data));
    },
    getPostalCode() {
      let selectedSubDistrict = _.find(
        this.subDistricts,
        (subDistrict) =>
          subDistrict.sub_district_code == this.form.sub_district_code
      );
      this.form.sub_district_name = selectedSubDistrict.sub_district_th;
      this.form.sub_district_name_en = selectedSubDistrict.sub_district_en;
      this.form.post_code = selectedSubDistrict.postcode;
    },
    doRegistration() {
      this.form.domain = _.trim(_.toLower(this.form.domain_name)) + this.form.tld;
      this.form.tax_id = _.replace(this.form.tax_id,/[\s!@#$%^&*()_+<>=\-\/|\\]/g,'');
      this.form.telephone = _.replace(this.form.telephone, /([+-\s])/g, '');
      this.form.province_code = this.form.province_code.toString();
      this.form.district_code = this.form.district_code.toString().slice(-2);
      this.form.sub_district_code = this.form.sub_district_code.toString().slice(-2);
      if (this.form.need_sale_page == true) {
        var selected_vendor = _.find(this.vendors.data,(vendor) => {
          return vendor.id == this.form.package_id
        });
        this.form.vendor_id = selected_vendor.vendor_id;
        this.form.package_id = selected_vendor.id;
      }

      this.form.post(route("registrations.store"), {
        preserveScroll: true,
        onSuccess: () => this.form.reset(),
      });
    },
    startAgain() {
      this.isOpenNextSteps = false;
      this.domainResult = null;
    },
    checkDomain() {
      this.isChecking = true;
      this.isOpenNextSteps = false;

      axios
        .post(
          route("dotarai.check_domain", {
            domain_name: _.trim(_.toLower(this.form.domain_name)),
            tld: this.form.tld,
          })
        )
        .then((response) => {
          if (response.data.result == 'success') {
            if (response.data.data == true)
              this.isOpenNextSteps = true;

            this.domainResult = response.data.message;
          } else {
            this.domainResult = response.data.message;
          }

          this.isChecking = false;
        });
    },
  },
  computed: {
    isDomainValid() {
      return !this.$isEmpty(this.form.domain_name);
    },
  },
};
</script>
